export const KBA_PARTNER_ID = 3

const kbaPartners = [
  { id: 1, name: 'American Bird Conservancy' },
  { id: 2, name: 'Amphibian Survival Alliance' },
  { id: KBA_PARTNER_ID, name: 'BirdLife International' },
  { id: 4, name: 'Conservation International' },
  { id: 5, name: 'Critical Ecosystem Partnership Fund' },
  { id: 6, name: 'Global Environment Facility' },
  { id: 7, name: 'IUCN' },
  { id: 8, name: 'NatureServe' },
  { id: 9, name: 'Rainforest Trust' },
  { id: 10, name: 'Re:wild' },
  { id: 11, name: 'Royal Society for the Protection of Birds' },
  { id: 12, name: 'WWF' },
  { id: 13, name: 'Wildlife Conservation Society' }
]

export default kbaPartners
